module.exports = __webpack_public_path__ + "static/img/category_40.5892c2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/category_40.jpg
// module id = PkWn
// module chunks = 0